<template>
  <div>
    <h1>Sign Up</h1>
    <form @submit.prevent="signUp">
      <input v-model="email" type="email" placeholder="Enter your email" required>
      <input v-model="password" type="password" placeholder="Enter your password" required>
      <input v-model="name" type="text" placeholder="Enter your name" required>
      <button type="submit">Sign Up</button>
    </form>
    <p v-if="error" class="error">{{ error }}</p>
    <p>
      Already have an account? <button @click="showLogin">Log In</button>
    </p>
  </div>
</template>

<script>
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { db } from '../firebase-config';
import { collection, addDoc } from 'firebase/firestore';

export default {
  data() {
    return {
      email: '',
      password: '',
      name: '',
      error: ''  // Track error messages
    };
  },
  methods: {
    async signUp() {
      const auth = getAuth();
      try {
        const userCredential = await createUserWithEmailAndPassword(auth, this.email, this.password);
        const user = userCredential.user;
        // Add a document with user's data
        await addDoc(collection(db, 'users'), {
          uid: user.uid,
          email: user.email,
          name: this.name
        });
        alert('Signup successful!');
        this.error = '';
        this.$router.push('/account');  // Navigate to the account page after successful sign up
      } catch (error) {
        this.error = error.message;  // Display any error encountered during signup
      }
    },
    showLogin() {
      this.$router.push('/login'); // Navigate to the login page
    }
  }
};
</script>

<style scoped>
button {
  margin-top: 10px;
}
.error {
  color: red;
}
</style>

